import React from "react";
import { BoxIcon } from "lucide-react";
export interface NavItem {
  id: string;
  label: string;
  icon: BoxIcon;
}
export function BottomNav({
  items,
  active,
  onChange
}: {
  items: NavItem[];
  active: string;
  onChange: (id: string) => void;
}) {
  return <nav className="shrink-0 border-t border-line bg-white px-2 pb-2 pt-1.5" aria-label="প্রধান নেভিগেশন" data-id="element-104" data-mp="28punvemcz1hq">
      <ul className="flex" data-id="element-105" data-mp="1g3064pgxeg7y">
        {items.map(it => {
        const on = it.id === active;
        return <li key={it.id} className="flex-1" data-id="element-106" data-mp="1l22zvdrgh00m">
              <button onClick={() => onChange(it.id)} className={`flex w-full flex-col items-center gap-0.5 rounded-lg py-1.5 text-[11px] font-semibold transition-colors duration-150 ${on ? 'text-navy' : 'text-ink-soft hover:text-ink-muted'}`} aria-current={on ? 'page' : undefined} data-id="element-107" data-mp="1l2uvupoyszrf">
                <span className={`flex h-7 w-12 items-center justify-center rounded-full ${on ? 'bg-navy-50' : ''}`} data-id="element-108" data-mp="xda8luls3gcc">
                  <it.icon className="h-5 w-5" data-id="element-109" data-mp="12aafu8ud6p51" />
                </span>
                {it.label}
              </button>
            </li>;
      })}
      </ul>
    </nav>;
}